// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__tQEH7","description":"PatientConsentPreview_description__1kV_v"};